import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import colors from '../styles/colors';

const LanguageSwitcherContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const LanguageButton = styled.button`
  background: ${props => props.active ? colors.primary.green : 'transparent'};
  color: ${props => props.active ? 'white' : colors.text.primary};
  border: 2px solid ${colors.primary.green};
  padding: 8px 16px;
  border-radius: 20px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
  font-size: 14px;

  &:hover {
    background: ${colors.primary.green};
    color: white;
    transform: translateY(-2px);
  }
`;

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <LanguageSwitcherContainer>
      <LanguageButton
        active={i18n.language === 'it'}
        onClick={() => changeLanguage('it')}
      >
        IT
      </LanguageButton>
      <LanguageButton
        active={i18n.language === 'pt'}
        onClick={() => changeLanguage('pt')}
      >
        PT
      </LanguageButton>
    </LanguageSwitcherContainer>
  );
};

export default LanguageSwitcher;
